<!--
 * @Description: 
 * @Author: zhaoshuai
 * @Date: 2021-03-29 14:34:32
 * @LastEditTime: 2021-06-03 16:49:11
 * @LastEditors: zhaoshuai
-->
<template>
  <div class="flex sharing-v">
    <Header />
    <secondStep titleMsg="缴纳补考费" />
    <div class="pay-wrapper">
      <p class="pay-price">支付补考费：<span>200</span>元</p>
      <div>
        <p class="pay-way" v-if="isMobile">请打开微信扫一扫完成缴费</p>
        <p class="pay-way" v-else>请长按二维码完成缴费</p>
        <div class="qrCode-wrapper">
          <!-- <div
            id="qrCode"
            ref="qrCodeDiv"
            logoSrc="http://guanhuifileserver.oss-cn-shanghai.aliyuncs.com/gk/2019-09-19/cd5bc30b2e4b43278711bf411dfe9d89-d8827c6294ed9ec4d7aed1af200865d.png"
          ></div> -->
          <vue-qr
            ref="Qrcode"
            :logoSrc="coverLogo"
            :text="text"
            :size="200"
            :margin="0"
            qid="testQrId"
          ></vue-qr>
        </div>

        <img src="@/assets/images/wxpay.png" alt="" />
      </div>
      <!-- 移动端支付 -->
      <!-- <div style="padding: 0 30px; margin-top: 30px" v-else>
        <a-button type="primary" block> 去支付 </a-button>
      </div> -->
      <div style="margin-top: 60px">
        <a href="/secondInfomation"
          ><a-button type="detault">上一步</a-button></a
        >
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "../components/Header";
import secondStep from "../components/common/secondStep";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("wx");
// import conf from "../assets/js/conf";
import VueQr from "vue-qr";
export default {
  name: "waitPay",
  components: {
    Header,
    secondStep,
    VueQr,
  },
  data() {
    return {
      isMobile: false,
      gameInfo: {},
      workId: "",
      codeUrl: "",
      qrcode: null,
      text: "333",
      timer: null,
      modalShow: false,
      modalGzh: false,
      coverLogo: require("@/assets/images/payLogo.png"),
    };
  },
  created() {
    this.getGameInfo();
  },
  destroyed() {
    window.clearInterval(this.timer);
  },
  mounted() {
    //判断是否是移动端
    this.flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    console.log(this.flag);
    if (this.flag === null) {
      console.log("pc端");
      this.isMobile = true;
    } else {
      console.log("移动端");
      this.isMobile = false;
    }
    //轮询订单状态
    // this.getPaymentStatus()
    // 判断是否订单信息拉取二维码
    this.showQrcode();
    // let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
    // this.getStudentInfo({
    //   orderCode: userInfo.orderCode,
    //   userCode: userInfo.userCode,
    // }).then((res) => {
    //   let studentInfo = res.data.data;
    //   this.userInfo = studentInfo;
    //   this.$previewRefresh();
    // });
  },
  methods: {
    ...mapActions([
      "getStudentInfo",
      "getOrderInfoAct",
      "createOrderAct",
      "createPayCodeAct",
    ]),
    //初始话二维码
    // setQrcode(url) {
    //   this.$nextTick(function () {

    //     this.$refs.qrCodeDiv.innerHTML = "";
    //     this.qrcode = new QRCode(this.$refs.qrCodeDiv, {
    //       text: url,
    //       width: 200,
    //       height: 200,
    //       src: "",
    //       colorDark: "#333333", //二维码颜色
    //       colorLight: "#ffffff", //二维码背景色
    //       correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
    //     });
    //     // this.qrcode.clear() //清除二维码
    //     // this.qrcode.makeCode("http://www.ccwt.org.cn/")
    //   }
    //   )
    // },

    //展示二维码
    async showQrcode() {
      const res = await this.getOrderInfoAct();
      if (res.data.status != 2000) return;
      let orderL = res.data.data;
      this.orderInfo = orderL.length == 0 ? {} : orderL[0];

      if (orderL.length == 0) {
        this.createOrderNew();
      } else {
        if (this.orderInfo.paymentStatus == 0) {
          this.createOrderNew();
        } else {
          this.$router.push("/successPay");
        }
      }
    },
    //获取订单信息
    async getGameInfo() {
      // const res = await this.getByUserCodeAct();
      // const rs = await this.getGameByIdAct(res.data[0].id);
      // const r = await this.getWorkInfoByCode();
      // this.gameInfo = rs.data;
      // this.workId = r.data[0].id;
    },
    /**
     * @description: 创建订单 新的函数
     * @param {type}
     * @return:
     */
    createOrderNew() {
      // let openId = localStorage.getItem("openId");
      // this.$bvModal.show("modalQrcode");

      // 创建订单
      this.createOrderAct({
        userCode: JSON.parse(localStorage.getItem("apply_userInfo")).userCode,
        productPackageID: "1377167147786063874",
        userName: JSON.parse(localStorage.getItem("apply_userInfo")).userName,
        mobile: JSON.parse(localStorage.getItem("apply_userInfo")).mobile,
        agencyCode: JSON.parse(localStorage.getItem("apply_userInfo"))
          .agencyCode,
        agencyName: JSON.parse(localStorage.getItem("apply_userInfo"))
          .agencyName,
      }).then((res) => {
        // console.log(4444)
        if (res.data.status == 2000) {
          this.createPayCodeAct({
            wxopenId: "",
            orderCode: res.data.data,
            price: "0.01",
          }).then((res) => {
            // this.createQrcode(re.data.codeUrl);

            this.text = res.data.data.codeUrl;
            // console.log(this.text)

            // this.setQrcode(res.data.codeUrl)
          });
        } else {
          alert("获取二维码失败");
        }
      });
    },
    /**
     * @description: 轮询支付状态
     * @param {*}
     * @return {*}
     */
    getPaymentStatus() {
      let times = 0;
      this.timer = setInterval(async () => {
        // console.log(333)
        const res = await this.getOrderInfoAct();
        if (res.data.data[0].paymentStatus) {
          // this.modalShow = false;
          this.$router.push("/successPay");
        }
        times += 1;
        this.outtime(times);
      }, 1000);
    },
    outtime(times) {
      if (times == 60 * 5) {
        const h = this.$createElement;
        const vNodesMsg = h("p", [
          h("i", this.$tips(0)),
          "二维码已失效，请刷新重试",
        ]);
        this.$bvToast.toast(vNodesMsg, {
          toaster: "b-toaster-top-center",
          noCloseButton: true,
        });
      }
    },
  },
};
</script>

<style scoped>
.pay-wrapper {
  text-align: center;
}
.pay-price {
  margin-top: 40px;
  margin-bottom: 30px;
  font-size: 30px;
  color: #000;
}
.pay-price span {
  color: #b01f21;
  font-size: 48px;
}
.pay-way {
  color: #b01f21;
  font-size: 16px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.qrCode-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}
@media (max-width: 575px) {
  .pay-price {
    margin-top: 20px;
    margin-bottom: 15px;
    font-size: 20px;
    color: #000;
  }
}
</style>
